import { Search } from "@mui/icons-material";
import { Box, Typography, styled } from "@mui/material";

export const S = {
    EmptyState: styled(Box)(({ theme }) => ({
        padding: theme.spacing(4),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        maxWidth: 480,
        margin: "auto",
        elevation: 0,
    })),

    Hero: styled(Box)(({ theme }) => ({
        marginBottom: theme.spacing(3),
        height: 120,
        width: 120,
        borderRadius: theme.spacing(20),
        backgroundColor: "rgba(0, 0, 0, 0.04)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.primary.main,
    })),

    Title: styled(Typography)(({ theme }) => ({
        marginBottom: theme.spacing(3),
        color: theme.palette.text.secondary,
        mx: "auto",
    })),

    SearchIcon: styled(Search)(({ theme }) => ({
        fontSize: 48,
        opacity: 0.6,
    })),
};
